<ng-container *ngrxLet="loaderState$ as state">
  @if(state){
  <div class="loader-container">
    <div class="loader">
      <div class="circle"></div>
      <div class="title-small-bold">Loading</div>
    </div>
  </div>
  }
</ng-container>
